// extracted by mini-css-extract-plugin
module.exports = {"container":"MinistryTeam1000_container__261Yo","errorMessage":"MinistryTeam1000_errorMessage__3ZOEM","deleteIcon":"MinistryTeam1000_deleteIcon__33lB5"};